export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-feenex-blue">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/66afc4a4f36630a77b3b506d73b2192d.jpg"
          alt="Feenex Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-feenex-blue/95 via-feenex-blue/90 to-feenex-blue/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/5 backdrop-blur-sm rounded-full border border-feenex-gold/30 mb-8">
            <div className="w-2 h-2 bg-feenex-gold rounded-full"></div>
            <span className="text-sm font-medium text-feenex-white tracking-wide">
              Soluções Corporativas em Direitos Creditórios
            </span>
          </div>

          {/* Main Headline */}
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight mb-6">
            Feenex: Redução de 20% nos seus impostos federais, de forma simples e legal
          </h2>
          
          <p className="text-xl text-feenex-white/90 leading-relaxed mb-10 max-w-3xl">
            A Feenex oferece soluções estruturadas em ativo moeda/direitos creditórios&nbsp;para empresas do Lucro Real ou Presumido que buscam eficiência tributária com total conformidade legal e transparência.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-20">
            <a href="#solucoes" className="px-8 py-4 bg-feenex-gold hover:bg-feenex-gold/90 text-feenex-blue font-semibold rounded-md transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Conhecer Soluções
            </a>
            <a href="#contato" className="px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold rounded-md border border-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Agendar Conversa Gratuita
            </a>
            <a href="https://wa.me/5511947705303" target="_blank" rel="nofollow noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-[#128C7E] hover:bg-[#0e7a6d] text-white font-semibold rounded-md transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp
            </a>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-12">
            <div>
              <div className="text-4xl font-bold text-feenex-gold mb-2">100%</div>
              <div className="text-sm text-feenex-white/70 uppercase tracking-wider">Conformidade Legal</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-feenex-gold mb-2">R$ 24Bi+</div>
              <div className="text-sm text-feenex-white/70 uppercase tracking-wider">Em Créditos disponíveis</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-feenex-gold mb-2">550+</div>
              <div className="text-sm text-feenex-white/70 uppercase tracking-wider">Empresas Atendidas pela feenex/monetali</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 text-feenex-gold/60 animate-bounce">
          <span className="text-xs uppercase tracking-wider">Saiba Mais</span>
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}
